import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'
import { useHall } from '$logic/hall/react-hook'
import { WithQueryTitleWrapper } from '$common/room-list-search/with-query-title-wrapper/with-query-title-wrapper'

const StyledTypography = styled(Typography)`
  margin-right: 4px;
  display: contents;
`

export function HallListItemTitle({ hallId }: { hallId: string }) {
  const { entity: hall } = useHall(hallId)
  const title = hall?.name

  return (
    <WithQueryTitleWrapper>
      <StyledTypography variant="subtitle3" noWrap>
        {title}
      </StyledTypography>
    </WithQueryTitleWrapper>
  )
}
